import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useBackgroundColor from 'Hooks/useBackgroundColor';
import {
  ScenarioLoadingProvider,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/Header/ScenarioLoadingIndicator/ScenarioLoadingContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import {
  LinterDrawerProvider,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/LinterDrawer/LinterDrawerContext';
import LeftSide from './LeftSide';
import RightSide from './RightSide';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'row',
    flexGrow: 1,
    flexBasis: 0,
    flexShrink: 1,
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    minHeight: `calc(100vh - ${theme.heights.advisorNavigationHeight}px)`,
    height: `calc(100vh - ${theme.heights.advisorNavigationHeight}px)`,
    position: 'relative',
    overflowX: 'hidden',
    maxWidth: '100%',
  },
  leftSide: {
    flexShrink: 0,
  },
  rightSide: {
    flexGrow: 1,
    minWidth: theme.dimensions.md,
  },
});

const WhatIfTemplateContent = ({
  className,
  classes,
}) => {
  const theme = useTheme();
  useBackgroundColor(theme.palette.facet.lightGray);
  const { isPageContentLoading, pageContentLoadingError } = usePageContentContext();
  return (
    <ScenarioLoadingProvider isPageContentLoading={isPageContentLoading} pageContentLoadingError={pageContentLoadingError}>
      <LinterDrawerProvider>
        <Box
          className={classNames(classes.root, className)}
        >
          <LeftSide className={classes.leftSide} />
          <RightSide className={classes.rightSide} />
        </Box>
      </LinterDrawerProvider>
    </ScenarioLoadingProvider>
  );
};

WhatIfTemplateContent.defaultProps = {
  className: '',
};

WhatIfTemplateContent.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(WhatIfTemplateContent);
